/* eslint-disable angular/controller-as */

angular.
module("dx.webapp.library").
controller("DxLibraryQuestionItemController", function libraryQuestionItemController(
	$scope,
	$rootScope,
	$timeout,

	Broadcaster
) {
	"use strict";

	// The expand class should not be applied until after the template has been rendered for an animated transition to happen.
	$timeout(function templateRendered() {
		$scope.rendered = true;
	});

	$scope.isPreviewing = false;

	$scope.toggleSelected = function toggleSelected($event) {
		$scope.selected = !$scope.selected;
		$scope.dxExamLibraryCtrl.setQuestionSelected($scope.question.id, $scope.selected);
		$event.stopPropagation();
	};

	$scope.$on("DxExamLibraryController:questionsSelectedUpdated", function updateSelected(event, selectedQuestionIds) {
		$scope.selected = selectedQuestionIds.indexOf($scope.question.id) !== -1;
	});

	$rootScope.$on("question-preview", function onQuestionPreview() {
		if ($scope.question.id === Broadcaster.message) {
			return;
		}

		$scope.isPreviewing = false;
	});

	return $scope.$watch("isPreviewing", function watchIsPreviewing() {
		if (!$scope.isPreviewing) {
			return;
		}

		Broadcaster.broadcast("question-preview", $scope.question.id);
	});
});
